module.exports = "/images/9c43c8642e53d6419abab67db94e468e.svg";